import styled, { keyframes } from 'styled-components';

interface Props extends SvgProps {
  speed?: number;
  className?: string;
}

export const LoadingIndicator = (props: Props) => {
  return (
    <div className={`${props.className} w-screen h-screen absolute flex align-center justify-center items-center `}>
      <Svg viewBox="-24 -24 48 48" className={'stroke-gray-200'} small={props.small}>
        <CircleSVG cx="0" cy="0" r="20" fill="none" strokeWidth="4" />
      </Svg>
    </div>
  );
};

const speed = 1.5;

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 0, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 100, 150;
    stroke-dashoffset: -24;
  }
  100% {
    stroke-dasharray: 0, 150;
    stroke-dashoffset: -124;
  }
`;

interface SvgProps {
  small?: boolean;
}

const Svg = styled.svg<SvgProps>`
  animation: ${rotate} ${speed * 1.75}s linear infinite;
  height: ${p => (p.small ? '1.25rem' : '3rem')};
  width: ${p => (p.small ? '1.25rem' : '3rem')};
  transform-origin: center;
`;

const CircleSVG = styled.circle`
  animation: ${dash} ${speed}s ease-in-out infinite;
  stroke: ${p => p.theme.primary};
  stroke-linecap: round;
`;
